<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 195.46 80"
  >
    <g class="menu-svg menu-svg--heart">
      <path
        fill="currentColor"
        d="M117.27 7.27a16.476 16.476 0 00-16 12.45C99.09 10.88 90.16 5.49 81.32 7.67a16.468 16.468 0 00-12.53 16.05c0 4.25 1.93 8.35 4.23 11.54 7.69 10.63 28.25 34.6 28.25 34.6S123 45.06 129.5 35.31c1.71-2.55 4.24-7.32 4.24-11.53.01-9.1-7.36-16.49-16.46-16.5 0-.01-.01-.01-.01-.01z"
      />
      <path
        fill="#F39A2C"
        d="M124.28 26.97l-3.14-2.52s1.08-7.66-5.41-8.51c-9-1.17-6.35 11.74-8.86 13.68-5.2-5.31-14.77-9.45-14.77-9.45s2 13.73 5.87 18.63c.27.36.58.7.92 1a6.472 6.472 0 01-2.75-2.1A22.284 22.284 0 0193 31.03c-3.72-.72-7.28-2.08-10.54-4l.11.23-.19-.17c.09 11.34 7.13 20.85 16.78 21.92 10.57 1.16 20.3-8.16 21.76-20.84l3.36-1.2z"
      />
      <path
        fill="#FFF"
        d="M117.77 23.47c-.26.95-1.25 1.5-2.19 1.24s-1.5-1.25-1.24-2.19c.26-.95 1.25-1.5 2.19-1.24h.01c.94.27 1.48 1.24 1.22 2.18"
      />
      <path
        fill="#6A3619"
        d="M117 23.25c-.12.49-.61.79-1.1.68h-.09c-.52-.1-.87-.58-.81-1.1a1.004 1.004 0 011.34-.74c.47.13.76.6.66 1.08v.09"
      />
    </g>
    <path
      fill="currentColor"
      d="M0 47.63h8.57L11.2 57.9l2.91-10.27h8.37v4.38H21v15.95h1.52v4.35h-8v-4.35h1.23l.36-15.25-4.2 14.62H9.8L6.08 52.65v15.31h1.28v4.35H0v-4.35h1.52V52.01H0v-4.38zm24.29 24.69v-4.35h1.52V52.01h-1.52v-4.38h8.85v4.38H31.6v15.95h1.54v4.35h-8.85zm10.13 0v-4.35h1l4.85-7.64-4.89-8.31h-.9v-4.38h7.92v4.38h-1.28l2.14 3.68 2.34-3.68h-1.37v-4.38h7.09v4.38h-.76l-4.8 7.59 4.74 8.36h.84v4.35h-7.89v-4.35h1.26l-2-3.68-2.3 3.68h1.11v4.35h-7.1zm18.18 0v-4.35h1.52V52.01H52.6v-4.38h8.83v4.38h-1.52v15.95h1.52v4.35H52.6zm14.32 0v-4.35h1.52v-16.3h-1.91v3.79h-3.37v-7.82h16.36v7.85h-3.37v-3.8h-1.92v16.28h1.48v4.35h-8.79zm55.87.06v-4.34h1.52v-16h-1.52v-4.41h8.58v4.38h-1.27v7.3l4.78-7.3h-1.67v-4.38h8v4.38h-1.35l-4.78 7.29 4.9 8.74h1.27v4.34h-8.17v-4.34h1.38l-4.38-8.58v8.58h1.27v4.34h-8.56zm19.36-.06v-4.35h1.52V52.01h-1.52v-4.38H151v4.38h-1.52v16.1h4.09v-4.27h4.52v8.47h-15.94zm18.35-6.25V52.01H159v-4.38h8.58v4.38h-1.27v13.74c0 1.53.67 2.29 2 2.29s2-.76 2-2.29V52.01h-1.26v-4.38h8.53v4.38h-1.48v14.06c0 4.5-2.61 6.75-7.82 6.75-2.07.15-4.13-.46-5.78-1.72a6.45 6.45 0 01-2-5.03zm18.93 6.25v-4.35H181V52.01h-1.52v-4.38h8.73c2.36 0 4.1.45 5.2 1.36a5.247 5.247 0 011.67 4.3v.65c.1 1.34-.29 2.66-1.08 3.74-.92.94-2.16 1.51-3.48 1.58 1.41.07 2.75.63 3.8 1.58a5.321 5.321 0 011.19 3.77v1.12c0 2.34-.52 4-1.58 5s-2.77 1.52-5.17 1.52l-9.33.07zm7-15.01h1c.67.06 1.34-.09 1.92-.43.37-.27.53-.84.53-1.69v-1.33c.06-.61-.13-1.21-.53-1.67a2.64 2.64 0 00-1.84-.52h-1.05l-.03 5.64zm0 11.01h1.08c.71.08 1.41-.15 1.94-.63.43-.61.63-1.36.56-2.11v-1.95c.05-.66-.18-1.32-.63-1.81a3 3 0 00-2-.58h-1l.05 7.08z"
    />
  </svg>
</template>

<style lang="scss">
.menu-svg{
	will-change: opacity, transform;
	transition: transform $transition-duration * 2, opacity $transition-duration * 2;

	[aria-expanded="true"] &--spoon{
		transform: rotate(30deg) translate(20px, -30px);
	}

	[aria-expanded="true"] &--eye{
		transform: translate(0.7px, 0.7px);
	}

	[aria-expanded="true"] &--dot1{
		transform: translate(12px, 12px);
		opacity: 0;
	}

	[aria-expanded="true"] &--dot2{
		transform: translate(-12px, -45px);
	}

	[aria-expanded="true"] &--arm{
		transform: rotate(30deg) translate(5px, -30px);
	}

	[aria-expanded="true"] &--arm2{
		transform: rotate(-30deg) translate(-24px, 10px);
	}

	&--eye2{
		transform: translate(-0.7px, 0.7px);
	}

	[aria-expanded="true"] &--eye2{
		transform: translate(-0.7px, -0.7px);
	}

	[aria-expanded="true"] &--heart{
		transform: rotate(-10deg) translate(-8px, 13px);
	}
}
</style>
